module.exports.LOGIN = 'LOGIN';
module.exports.LOGIN_ERROR = 'LOGIN_ERROR';
module.exports.LOGOUT = 'LOGOUT';
